import React, { useContext } from 'react'
import './index.css'
import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom'
import Login from './pages/Auth/Login'
import SignUp from './pages/Auth/SignUp'
import UserDashboard from './pages/User/UserDashboard'
import PrivateRoute from './routes/PrivateRoute'
import CreateTask from './pages/Admin/CreateTask'
import ManageUsers from './pages/Admin/ManageUsers'
import ManageTasks from './pages/Admin/ManageTasks'
import Project from './pages/Admin/Project'
import MyTasks from './pages/User/MyTasks'
import ViewTaskDetails from './pages/User/ViewTaskDetails'
import VerifyOTP from './pages/Auth/VerifyOtp'
import ForgotPassword from './pages/Auth/ForgotPassword'
import UserProvider, { UserContext } from './context/UserContext'
import Dashboard from './pages/Admin/Dashboard'
import { Toaster } from 'react-hot-toast'
import ProjectList from './pages/Admin/ProjectList'
import ProjectDetails from './pages/Admin/ProjectDetails'

const App = () => {
  return (
     <UserProvider>
    <div>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/verify-otp" element={<VerifyOTP />} />
          <Route path="/forgot" element={<ForgotPassword />} />

          {/* Admin Routes */}
          <Route element={<PrivateRoute allowedRoles={['admin']} />}>
            <Route path="/admin/dashboard" element={<Dashboard />} />
            <Route path="/admin/tasks" element={<CreateTask />} />
            <Route path="/admin/manage-users" element={<ManageUsers />} />
            <Route path="/admin/manage-tasks" element={<ManageTasks />} />
            <Route path="/admin/project"  element={<Project/>}/>
            <Route path="/admin/project-list"  element={<ProjectList/>}/>
            <Route path="/admin/projects/:id"  element={<ProjectDetails/>}/>
          </Route>

          {/* User Routes */}
          <Route element={<PrivateRoute allowedRoles={['user']} />}>
            <Route path="/user/dashboard" element={<UserDashboard />} />
            <Route path="/user/tasks" element={<MyTasks />} />
            <Route path="/user/tasks-details/:id" element={<ViewTaskDetails />} />
          </Route>

          {/* Root Redirect */}
          <Route path="*" element={<Root />} />
        </Routes>
      </BrowserRouter>
   
    </div>

    <Toaster toastOptions={{
      className:"",
      style: {
        fontSize:"13px"
      },
    }}/>
  </UserProvider>
  )
}

export default App

const Root = () => {
  const { user, loading } = useContext(UserContext)

  if (loading) return <p>Chargement...</p>

  if (!user) {
    return <Navigate to="/" replace />
  }

  return user.role === 'admin'
    ? <Navigate to="/admin/dashboard" replace />
    : <Navigate to="/user/dashboard" replace />
}
